import styled from "@emotion/styled";

export const FormsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  padding-top: 30px;
`;

export const RowsContainer = styled.div`
  width: 50%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0 10px 0;
`;

export const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-top: 30px;
`;
